import { IWB_THEME } from "@gemini/tokens";
import { KAMELEOON_BRAND_SITE_CODE, KAMELEOON_CONSENT_IDS, KAMELEOON_TECHNICAL_CONSENT_IDS, } from "@aviv-trak/feature-flagging";
import { getCookieDomain } from "@aviv-unified-frontend/internal";
import { createConsentServiceHook } from "../../../src/utils/consentManagement";
import { ENVIRONMENT, STAGE_LIKE_ENVIRONMENT, VERSION_EPHEMERAL, } from "../../../src/constants/environment";
import { createB2CBrand } from "../createB2CBrand";
const origin = {
    dev: "https://dev.immoweb.be",
    preview: "https://preview.immoweb.be",
    live: "https://www.immoweb.be",
};
const consentID = {
    dev: "Bse70w_yBEj_bC",
    preview: "Bse70w_yBEj_bC",
    live: "Bse70w_yBEj_bC",
};
const airshipConfig = {
    dev: {
        appKey: "hIWsk9oIQYuOGcKjjPtSew",
        token: "MTpoSVdzazlvSVFZdU9HY0tqalB0U2V3OmhZTlJlZWIyQ1o3QVZCUThCVFZNQ0YwT2ZzT1ZvN01LSnROZUhmdkJkcUU",
        vapidPublicKey: "BPXr_P5usUVl6Pcf4cAUxXacBK2JNbvvJrDCm9LT0JRzTNHTJRKurUgAkSmulKX_9UZDmb_9Mrsl8wkp_hoTLEo=",
    },
    preview: {
        appKey: "hIWsk9oIQYuOGcKjjPtSew",
        token: "MTpoSVdzazlvSVFZdU9HY0tqalB0U2V3OmhZTlJlZWIyQ1o3QVZCUThCVFZNQ0YwT2ZzT1ZvN01LSnROZUhmdkJkcUU",
        vapidPublicKey: "BPXr_P5usUVl6Pcf4cAUxXacBK2JNbvvJrDCm9LT0JRzTNHTJRKurUgAkSmulKX_9UZDmb_9Mrsl8wkp_hoTLEo=",
    },
    live: {
        appKey: "omFuYp09RWCudBz5bYneUQ",
        token: "MTpvbUZ1WXAwOVJXQ3VkQno1YlluZVVROnowcW5zQmFwRUpSUmFJWnZUZ2RGM1B0U21UdzZ1OUg2T3h3cHFfSTlfQXc",
        vapidPublicKey: "BDVSwFOo5uQ9UltkVQ7HOtvPsiSXNdccFKbkN4jZoOyDy8hLGCJaZIDXvs_SPpiZ62oCFXXahVP_DgucboqJq_0=",
    },
};
const authenticationConfig = {
    dev: {
        cookies: {
            expirationToken: "oauth.expiration.token",
            accessToken: "oauth.access.token",
            refreshToken: "oauth.refresh.token",
        },
        urls: {
            refresh: "https://dev-signin.immoweb.be/refresh",
            signIn: "https://dev-signin.immoweb.be/?redirect_uri=",
        },
    },
    preview: {
        cookies: {
            expirationToken: "oauth.expiration.token",
            accessToken: "oauth.access.token",
            refreshToken: "oauth.refresh.token",
        },
        urls: {
            refresh: "https://preview-signin.immoweb.be/refresh",
            signIn: "https://preview-signin.immoweb.be/?redirect_uri=",
        },
    },
    live: {
        cookies: {
            expirationToken: "oauth.expiration.token",
            accessToken: "oauth.access.token",
            refreshToken: "oauth.refresh.token",
        },
        urls: {
            refresh: "https://signin.immoweb.be/refresh",
            signIn: "https://signin.immoweb.be/?redirect_uri=",
        },
    },
};
export default createB2CBrand({
    id: "iwb",
    name: "Immoweb",
    defaultTitle: "Immoweb",
    defaultDescription: "Immoweb",
    theme: IWB_THEME,
    i18n: {
        supportedLanguageTags: ["en-GB", "fr-BE", "nl-BE"],
        languageDetection: true,
        defaultLanguageTag: "en-GB",
    },
    portal: "immoweb.be",
    origin: origin[STAGE_LIKE_ENVIRONMENT],
    consentManagement: {
        id: consentID[STAGE_LIKE_ENVIRONMENT],
    },
    qualtrics: {
        id: "ZN_2VBZuKAg5IqzLaC",
        id_url: "QSI_S_ZN_2VBZuKAg5IqzLaC",
        url: "https://zn2vbzukag5iqzlac-avivgroup.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_2VBZuKAg5IqzLaC",
    },
    airship: {
        ...airshipConfig[STAGE_LIKE_ENVIRONMENT],
        trackingConsentId: "GeAHebT3t1V6Fa",
        pushConsentId: "EbPkTecUeThu2B",
    },
    featureFlags: {
        getTrackingUserConsent: createConsentServiceHook(KAMELEOON_CONSENT_IDS["iwb"]),
        getTechnicalUserConsent: createConsentServiceHook(KAMELEOON_TECHNICAL_CONSENT_IDS["iwb"]),
        parameters: {
            siteCode: KAMELEOON_BRAND_SITE_CODE["iwb"],
            environment: STAGE_LIKE_ENVIRONMENT,
            domain: getCookieDomain(origin, ENVIRONMENT, `immoweb-${VERSION_EPHEMERAL}-b2c-shell.unified-spider-dev.aws.aviv.eu`, VERSION_EPHEMERAL),
        },
    },
    authentication: authenticationConfig[STAGE_LIKE_ENVIRONMENT],
});
